// extracted by css-extract-rspack-plugin
var _1 = "table-uq59vq";
export { _1 as "table" }
